import * as React from 'react';
import ABSIcon from '../ABSIcon';
import { Tooltip } from 'antd';
import '../ABSBubble/index.less';
import './index.less';

export declare type TooltipPlacement = 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom';

export interface IABSIconTooltipProps {
  text?: string|React.ReactNode;
  details: string|React.ReactNode;
  antType?: string;
  type?: string;
  width?: number;
  placement?: TooltipPlacement;
  overlayClassName?: string;
  visible?: boolean;
  defaultVisible?: boolean;
  onVisibleChange?: (visible?: boolean) => void;
  iconSize?: number;
}

export default class ABSIconTooltip extends React.Component<IABSIconTooltipProps> {
  static defaultProps = {
    defaultVisible: false,
    iconSize: 14
  };

  constructor(props: IABSIconTooltipProps) {
    super(props);
  }

  public render() {
    const { text, details, antType, type, width, 
      placement, overlayClassName, defaultVisible, 
      visible, onVisibleChange, iconSize 
    } = this.props;
    const isAnt = type ? false : true;
    const antIconType = antType ? antType : 'info-circle'; 
    const tooltipWidth = width ? width : 'auto';
    const position = placement ? placement : 'top';
    const setvisible = visible !== undefined ? { visible } : {};
    return (
      <span className={'abs-icon-tooltip'}>
        {text ? <span className="abs-text">{text}</span> : null}
        <Tooltip 
          overlayStyle={{'width': tooltipWidth }} 
          placement={position} 
          title={details} 
          arrowPointAtCenter={true} 
          overlayClassName={overlayClassName} 
          defaultVisible={defaultVisible}
          onVisibleChange={onVisibleChange}
          {...setvisible}
        >
          <span className="abs-icon-tooltip-icon-content">
          <ABSIcon size={iconSize} isAnt={isAnt} className="abs-icon" type={type || antIconType} />
          </span>
        </Tooltip>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSIconTooltip/index.tsx